<template>
    <div class="row mx-auto" v-if="userStore.user.isBusinessUser">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="card">
                <div class="pb-5 px-sm-0">
                    <div class="px-sm-4 mx-50">
                        <div class="card-header">
                            <h1 class="mx-auto">
                                {{ localizationStore.translate('team.detail.title') }}
                            </h1>
                        </div>
                        <p class="text-center mb-5">
                            Invite up to 3 team members to your <strong>Team</strong>.
                            <br>
                            Once your team member registers, they will have access to service your clients.
                        </p>
                        <div class="row mb-4">
                            <div class="col-12 col-lg-4">
                                <div class="d-flex justify-content-center mb-1">
                                    <div class="
                                        d-flex
                                        width-100
                                        height-100
                                        rounded-circle
                                        justify-content-center
                                        align-items-center
                                        bg-light-primary
                                    ">
                                        <vue-feather type="mail" />
                                    </div>
                                </div>
                                <div class="text-center">
                                    <h6 class="fw-bolder mb-1">Send Team Invite 💌</h6>
                                    <p>Send your invitation link to a team member via email.</p>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="d-flex justify-content-center mb-1">
                                    <div class="
                                        modal-refer-earn-step
                                        d-flex
                                        width-100
                                        height-100
                                        rounded-circle
                                        justify-content-center
                                        align-items-center
                                        bg-light-primary
                                    ">
                                        <vue-feather type="clipboard" size="2rem" />
                                    </div>
                                </div>
                                <div class="text-center">
                                    <h6 class="fw-bolder mb-1">Member Registers 👩🏻&zwj;💻</h6>
                                    <p>Team members creates a Creditfixrr "Team" Account.</p>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="d-flex justify-content-center mb-1">
                                    <div class="
                                        modal-refer-earn-step
                                        d-flex
                                        width-100
                                        height-100
                                        rounded-circle
                                        justify-content-center
                                        align-items-center
                                        bg-light-primary
                                    ">
                                        <vue-feather type="award" size="2rem" />
                                    </div>
                                </div>
                                <div class="text-center">
                                    <h6 class="fw-bolder mb-1">Service Your Clients 🎉</h6>
                                    <p>Team member gets Access to Service Your Clients.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="teamStore.team.team == null">
                    <div class="col-lg-4"></div>
                    <div class="col-lg-4">
                        <slot name='createTeam'></slot>
                    </div>
                    <div class="col-lg-4"></div>
                </div>
                <div class="row" v-else>
                    <div class="col-10 mx-auto">
                        <ul class="nav nav-pills mb-2 team">
                            <li class="nav-item">
                                <a class="nav-link" href="#" :class="{ active: activeTab == 1 }" @click.prevent="activeTab = 1">
                                    <vue-feather type="user" />
                                    <span class="fw-bold">Dashboard</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" :class="{ active: activeTab == 2 }" @click.prevent="showPermissions">
                                    <vue-feather type="shield" />
                                    <span class="fw-bold">Permissions</span>
                                </a>
                            </li>
                        </ul>
                        <div class="card" :class="activeTab == 1 ? 'd-block' : 'd-none'">
                            <div class="card-body my-2 py-25">
                                <div class="row" v-if="Object.keys(teamStore.team).length">
                                    <div class="col-lg-4">
                                        <h6 class="mb-2"> Active Team</h6>
                                        <div class="media mb-1">
                                            <div class="avatar bg-light-primary rounded mr-1">
                                                <div class="avatar-content">
                                                    <vue-feather type="user" />
                                                </div>
                                            </div>
                                            <div class="users">
                                                <h6 class="mb-0">Team Owner: </h6><small>{{ teamStore.team.teamOwner.email }}</small>
                                            </div>
                                        </div>
                                        <div class="media mb-1">
                                            <div class="avatar bg-light-primary rounded mr-1">
                                                <div class="avatar-content">
                                                    <vue-feather type="briefcase" />
                                                </div>
                                            </div>
                                            <div class="users">
                                                <h6 class="card-text mb-0">Team Name: </h6>
                                                <small>
                                                    {{ teamStore.team.team.name }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="mt-2">
                                            <button
                                                type="button"
                                                data-target="#editTeamName"
                                                data-toggle="modal"
                                                class="btn btn-primary waves-effect waves-float waves-light mr-2"
                                            >
                                                {{ localizationStore.translate('team.form.edit.button.text') }}
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-outline-danger waves-effect waves-float waves-light mr-2"
                                                @click="deleteTeam()"
                                            >
                                                {{ localizationStore.translate('delete.form.delete.button.text') }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-lg-8">
                                        <h6 class="mb-2">Team Members</h6>
                                        <slot name="send_invite"></slot>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="tab-content table-responsive">
                                            <table class="table mb-0 ">
                                                <thead>
                                                    <tr>
                                                        <th>User</th>
                                                        <th>Role</th>
                                                        <th>Joined</th>
                                                        <th>Invite Code</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(member,index) in teamStore.team.members">
                                                        <td>{{ member.name }}</td>
                                                        <td>
                                                            <div class="badge badge-light-primary"> {{member.my_role}}</div>
                                                        </td>
                                                        <td>
                                                            {{ formartDate(member.pivot.created_at) }}
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            <div class="d-flex" v-if="teamStore.team.canDeleteMember">
                                                                <a
                                                                    href="#"
                                                                    v-if="member.id !== teamStore.team.teamOwner.id"
                                                                    @click.prevent="deleteMember(member.id)"
                                                                >
                                                                    <vue-feather type="trash" size="16px"/>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(invite,index) in teamStore.team.invites">
                                                        <td>
                                                            {{ invite.email }} <span class="text-info">(Invited)</span>
                                                        </td>
                                                        <td>
                                                            <div class="badge badge-light-info">
                                                                {{ localizationStore.translate('team.invite.badge.pending.text') }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {{ formartDate(invite.created_at) }}
                                                        </td>
                                                        <td>
                                                            <span
                                                                :id="`invite-code-${invite.id}`"
                                                                :data-clipboard-text="invite.token"
                                                                class="copy-invite-code"
                                                                role=button
                                                            >
                                                                {{ invite.token }}
                                                            </span>
                                                            
                                                            <div v-if="invite.is_token_expire" class="badge badge-danger">
                                                                {{ localizationStore.translate('team.invite.badge.expire.text') }}
                                                            </div>
                                                            <b-popover
                                                                :target="`invite-code-${invite.id}`"
                                                                placement="top"
                                                                triggers="hover"
                                                                :html="true"
                                                            >
                                                                <template #title>Invite Code</template>
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <p>
                                                                            Click to Copy Code
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </b-popover>
                                                        </td>
                                                        <td>
                                                            <div class="d-flex">
                                                                <div class=" mr-1">
                                                                    <a
                                                                        href="#"
                                                                        class="item mr-50"
                                                                        @click.prevent="resendInviteEmail(invite.id)"
                                                                        :id="`invite-resend-${invite.id}`"
                                                                    >
                                                                        <vue-feather type="send" size="16" />
                                                                        <b-popover
                                                                            :target="`invite-resend-${invite.id}`"
                                                                            placement="top"
                                                                            triggers="hover"
                                                                            :html="true"
                                                                        >
                                                                            <template #title>Invite Resend</template>
                                                                            <div class="row">
                                                                                <div class="col-12">
                                                                                    <p>
                                                                                        Email the Invite URL.
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </b-popover>
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        class="item mr-50"
                                                                        @click.prevent="sendInviteCode(invite.id)"
                                                                        :id="`invite-code-email-${invite.id}`"
                                                                    >
                                                                        <vue-feather type="key" size="16" />
                                                                        <b-popover
                                                                            :target="`invite-code-email-${invite.id}`"
                                                                            placement="top"
                                                                            triggers="hover"
                                                                            :html="true"
                                                                        >
                                                                            <template #title>Email Invite Code</template>
                                                                            <div class="row">
                                                                                <div class="col-12">
                                                                                    <p>
                                                                                        Email the Invite Code
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </b-popover>
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        class="item mr-50"
                                                                        @click.prevent="regenerateInviteCode(invite.id)"
                                                                        :id="`invite-code-regenerate-${invite.id}`"
                                                                    >
                                                                        <vue-feather type="refresh-ccw" size="16" />
                                                                        <b-popover
                                                                            :target="`invite-code-regenerate-${invite.id}`"
                                                                            placement="top"
                                                                            triggers="hover"
                                                                            :html="true"
                                                                        >
                                                                            <template #title>Regenerate Invite Code</template>
                                                                            <div class="row">
                                                                                <div class="col-12">
                                                                                    <p>
                                                                                        Regenerate Invite Code
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </b-popover>
                                                                    </a>
                                                                    <a
                                                                        href="#"
                                                                        class="item mr-50"
                                                                        @click.prevent="deleteInvitation(invite.id)"
                                                                        :id="`invite-delete-${invite.id}`"
                                                                    >
                                                                        <vue-feather type="trash" size="16" />
                                                                        <b-popover
                                                                            :target="`invite-delete-${invite.id}`"
                                                                            placement="top"
                                                                            triggers="hover"
                                                                            :html="true"
                                                                        >
                                                                            <template #title>Invite Delete</template>
                                                                            <div class="row">
                                                                                <div class="col-12">
                                                                                    <p>
                                                                                        Delete This Invite
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </b-popover>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- permissions -->
                        <div class="card" :class="activeTab == 2 ? 'd-block' : 'd-none'">
                            <div class="card-header">
                                <h4 class="card-title">Permission</h4>
                            </div>
                            <div class="card-body">
                                <p class="card-text">
                                    Select permission to assign to your team member.
                                </p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Permission</th>
                                            <th>Permissions</th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(label, key, index) in teamStore.labels" :key="key">
                                            <td>
                                                <p :for="key">{{ index + 1 }}</p>
                                            </td>
                                            <td>
                                                <p :for="key">{{ label }}</p>
                                            </td>
                                            <td>
                                                <div class="custom-control custom-checkbox">
                                                    <input
                                                        :id="key"
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        v-model="teamStore.permissions[key]"
                                                    />
                                                    <label class="custom-control-label" :for="key"></label>
                                                </div>
                                            </td>
                                        </tr>
                                        <div class="mt-2">
                                            <button type="button" class="btn btn-primary waves-effect waves-float waves-light mr-2" @click="savePermission">
                                                Save Permission
                                            </button>
                                        </div>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- end permissions -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <edit-team-modal></edit-team-modal>
</template>
<script>
import { useTeamStore } from '../../../stores/TeamStore.js'
import { useUserStore } from '../../../stores/UserStore.js'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { BPopover } from 'bootstrap-vue-3'
import Clipboard from 'clipboard';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {ref,reactive} from 'vue'
import EditTeamModal from './EditTeamModal'
import axios from 'axios';
import Swal from 'sweetalert2'
export default{
    name:'TeamLayout',
    components:{
        EditTeamModal,
        BPopover
    },
    setup(){
        return{
            localizationStore: useLocalizationStore(),
            teamStore: useTeamStore(),
            userStore: useUserStore(),
            activeTab: ref(1)
        }
    },
    created(){
        dayjs.extend(relativeTime);
    },
    mounted(){
        this.teamStore.fetchTeam();
        var copyInviteCode = new Clipboard('.copy-invite-code');
        copyInviteCode.on('success', function (e) {
            e.clearSelection();
            toastr.success('Invite Code is Copied', 'Copied!');
        });
    },
    methods:{
        formartDate(date){
            return dayjs(date).fromNow();
        },
        showPermissions(){
            this.fetchPermissions();
            this.activeTab = 2;
        },
        fetchPermissions(){
            const $this = this;
            const route = $this.$router.resolve(
                {
                    name: 'teams-permissions',
                    params: {
                        team: $this.teamStore.team.team.id,
                    }
                }
            );
            axios.post(route.href)
            .then(function(response) {
                if(response.data.error == true) {
                    $this.teamStore.labels = $this.teamStore.permissions = [];
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.teamStore.permissions = response.data.data.permissions;
                $this.teamStore.labels = response.data.data.labels;
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        },
        savePermission(){
            const $this = this;
            const route = $this.$router.resolve(
                {
                    name: 'teams-permissions-store',
                    params: {
                        team: $this.teamStore.team.team.id,
                    }
                }
            );
            let permissions = [];
            _.forEach($this.teamStore.permissions, function(value, key) {
                if (value) {
                    permissions.push(key);
                }
            });
            axios.post(
                route.href,
                permissions
            ).then(({data})=>{
                if(data.error != true){
                    toastr.success(data.message,'Permission Success');
                }
            }).catch(error=>{
                let errors = this.getError(error)
                for (const key in errors) {
                    if (Object.hasOwnProperty.call(errors, key)) {
                        const element = errors[key];
                        return toastr.error(`${element}`,'Invite Error');
                    }
                }
            })
        },
        resendInviteEmail(inviteId){
            const $this = this;
            const route = $this.$router.resolve(
                {
                    name: 'teams-invite-resend-email',
                    params: {
                        invite: inviteId,
                        team: $this.teamStore.team.team.id,
                    }
                }
            );
            axios.get(route.href).then(({data})=>{
                if(data.error != true){
                    toastr.success(data.message,'Invite Success')
                }else{
                    toastr.success(data.message,'Invite error')
                }
            });
        },
        sendInviteCode(inviteId) {
            const $this = this;
            Swal.fire({
                title: this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                text: this.localizationStore.translate('team.invite.resend.invite.code'),
                showCancelButton: true,
                confirmButtonText: 'Yes!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'teams-invite-resend-code',
                            params: {
                                invite: inviteId,
                                team: $this.teamStore.team.team.id,
                            }
                        }
                    );
                    axios.post(route.href)
                    .then(function (response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        getError(error){
            const errorMsg = "";

            if (!error.response) {
                return errorMsg;
            }
            if (error.response.data && error.response.data.errors) {
                return error.response.data.errors;
            }
            return errorMsg;
        },
        deleteInvitation(inviteId) {
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: $this.localizationStore.translate('not.revert'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'teams-invite-delete',
                            params: {
                                invite: inviteId
                            }
                        }
                    );
                    axios.get(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.teamStore.fetchTeam();
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        deleteMember(memberId) {
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: $this.localizationStore.translate('not.revert'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'destroy-teams-users',
                            params: {
                                team: $this.teamStore.team.team.id,
                                user: memberId
                            }
                        }
                    );
                    axios.delete(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.teamStore.fetchTeam();
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        deleteTeam() {
            const $this = this;
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: $this.localizationStore.translate('not.revert'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.$router.resolve(
                        {
                            name: 'destroy-teams',
                            params: {
                                team: $this.teamStore.team.team.id
                            }
                        }
                    );
                    axios.delete(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.teamStore.fetchTeam();
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        regenerateInviteCode(inviteId) {
            const $this = this;
            Swal.fire({
                title: this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                text: this.localizationStore.translate('team.invite.member.regenerate.invite.code'),
                showCancelButton: true,
                confirmButtonText: 'Yes!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    let index = _.findIndex($this.teamStore.team.invites, function(invite) { return invite.id == inviteId; });
                    const route = $this.$router.resolve(
                        {
                            name: 'team-member-regenerate-code',
                            params: {
                                invite: inviteId
                            }
                        }
                    );
                    axios.post(route.href)
                    .then(function (response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.teamStore.team.invites[index] = response.data.data.invite;
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            });
        }
    }
}
</script>
<style>
.team li.nav-item:hover {
    background: whitesmoke;
    border-radius: 4px;
}
</style>
